import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Alert from 'react-s-alert';
import { config } from "../constant";
import Select from 'react-select'
import FileUpload from "./file-upload";
import CloudStorage from "./integrations/cloud-storage";
import { commonFunction } from "../common-functions";
import AIStatus from './ai-status';
import SelectExcelSheet from './select-excel-sheet';
import AIExtractedDataReview from './ai-extracted-data-review';
import { combineAIExtractedSheetsToObject, processAIExtractedData } from '../../utils';

class UploadDataFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tid: this.props.tid,
            disabledNextStep: true,
            file: undefined,
            format: "",
            sheetArray: [],
            sindex: [],
            headerin: [],
            headers: [],
            filterSelect: [],
            filterName: '',
            filterValue: '',
            fileInput: undefined,
            showLoading: false,
            aiExtraction: false,
            aiExtractionInstruction: "",
            aiStatus: null, // { status, message, step, current, total, error, result }
            aiExtractedData: null
        }
        this.setformInput = this.setformInput.bind(this);
        this.fileUploadCallback = this.fileUploadCallback.bind(this);
        this.cloudStorageDataCallback = this.cloudStorageDataCallback.bind(this);
        this.handleAIExtractedDataChange = this.handleAIExtractedDataChange.bind(this);
    }

    handleAIExtractedDataChange(nextExtracted) {
        this.setState({ aiExtractedData: nextExtracted }, () => {
            const combinedData = combineAIExtractedSheetsToObject(nextExtracted);
            this.props.callback(this.props.skey, {
                aiExtraction: this.state.aiExtraction,
                aiExtractionInstruction: this.state.aiExtractionInstruction,
                aiStatus: this.state.aiStatus,
                aiExtractedData: nextExtracted,
                combinedData,
                headers: Object.keys(combinedData),
                file: this.state.file
            });
        });
    }

    getHeader(callback) {
        if (this.state.file) {
            var formData = new FormData(),
                link;

            Array.from(this.state.file).forEach(file => {
                formData.append('inputFile', file);
            });
            formData.append("sheetindex", JSON.stringify(this.state.sindex));
            formData.append("headersin", JSON.stringify(this.state.headerin));
            formData.append("documentId", this.state.tid);
            formData.append("filterName", this.state.filterName);
            formData.append("filterValue", this.state.filterValue);

            if (this.state.format === 'json') link = `${config.API_URL}api/v1/document/getjsontags`;
            else if (this.state.format === 'xml') link = `${config.API_URL}api/v1/document/getxmltags`;
            else link = `${config.API_URL}api/v1/document/getxlsxheaders`;

            if (this.state.format === 'xlsx') {
                const isSheetSelected = this.state.sindex.every(el => el > -1);
                if (!isSheetSelected) {
                    return;
                }
            }

            axios.post(link, formData)
                .then(data => {
                    if (Array.isArray(data.data)) {
                        this.setState({
                            headers: data.data
                        }, () => {
                            callback();
                        });
                    }
                    else Alert.error(data.data.message, {
                        position: 'bottom-right',
                        effect: 'slide',
                        timeout: 5000
                    });
                });
        }
        else callback();
    }

    setFilterSelect(data) {
        var filterSelect = []
        var i;
        for (i = 0; i < data.length; i++) {
            filterSelect.push({ value: data[i], label: data[i] });
        }

        this.setState({
            filterSelect: filterSelect,
        });
    }

    setformInput(e, key, index) {
        const tempObject = {};
        const value = e && e.target ? e.target.value : e.value;

        if (index !== undefined) {
            tempObject[key] = [...this.state[key]];
            tempObject[key][index] = value;
        }
        else {
            tempObject[key] = value;
        }

        this.setState(tempObject, () => {
            this.getHeader(() => {
                if (this.state.headers.length > 0) this.setState({
                    disabledNextStep: false
                });
                this.setFilterSelect(this.state.headers);

                this.props.callback(this.props.skey, {
                    aiExtraction: this.state.aiExtraction,
                    sindex: this.state.sindex,
                    headersin: this.state.headerin,
                    headers: this.state.headers,
                    format: this.state.format,
                    sheetArray: this.state.sheetArray,
                    file: this.state.file,
                    filterName: this.state.filterName,
                    filterValue: this.state.filterValue
                });
            });
        })
    }

    setformInputNoTarget(e, key) {
        this.setformInput({ 'target': { 'value': e.value } }, key)
    }

    async convertExcelToJsonUsingAI(excelFile, instruction = null) {
        const formData = new FormData();
        formData.append('file', excelFile); // File object from <input type="file">

        if (instruction) {
            formData.append('instruction', instruction);
        }
        try {
            this.setState({ aiStatus: { status: 'uploading', message: 'Uploading file...', step: 'uploading', current: 0, total: 0 } });
            const response = await axios.post(`${config.API_URL}api/v1/excel-to-json/convert`, formData);
            const data = response.data;
            const workbook = Array.isArray(data.result) ? data.result[0] : null;

            if (data.status !== 'completed' || !workbook || typeof workbook !== 'object' || Array.isArray(workbook)) {
                throw new Error(data.message || 'The converter returned an invalid response');
            }

            const aiStatus = {
                status: 'completed',
                message: data.message || 'Conversion successful',
                step: 'completed',
                current: 0,
                total: 0
            };
            const aiExtractedData = {
                filename: data.filename || excelFile.name,
                data: Object.keys(workbook).map(sheetName => ({
                    sheet_name: sheetName,
                    data: processAIExtractedData(workbook[sheetName])
                }))
            };

            this.setState({
                aiStatus,
                aiExtractedData,
                disabledNextStep: false
            }, () => {
                const combinedData = combineAIExtractedSheetsToObject(aiExtractedData);
                this.props.callback(this.props.skey, {
                    aiExtraction: this.state.aiExtraction,
                    aiExtractionInstruction: this.state.aiExtractionInstruction,
                    aiStatus,
                    aiExtractedData,
                    combinedData,
                    headers: Object.keys(combinedData),
                    file: this.state.file
                });
            });

            return data;
        } catch (error) {
            const message = error.response?.data?.detail || error.response?.data?.error || error.message || 'Conversion failed';
            this.setState({
                aiStatus: { status: 'failed', message, step: 'failed', current: 0, total: 0, error: message }
            });
            throw new Error(message);
        }
    }

    fileUploadCallback(data, files) {
        var fileType;
        if (files[0].type === 'application/json') fileType = 'json';
        else if (files[0].type === 'text/xml') fileType = 'xml';
        else fileType = 'xlsx';

        this.setState({
            format: fileType,
            disabledNextStep: true
        }, () => {
            if (this.state.aiExtraction && files.length > 0) {
                this.setState({
                    file: files
                }, () => {
                    this.convertExcelToJsonUsingAI(this.state.file[0], this.state.aiExtractionInstruction)
                        .catch(error => console.error('AI extraction failed:', error.message));
                });
                return;
            }

            if (this.state.format === 'xlsx') {
                if (data && Array.isArray(data)) {
                    const headerin = new Array(data.length).fill("row");
                    const sindex = new Array(data.length).fill(-1);
                    const sheetArray = data.map(el => {
                        const sheets = el.sheets.map(el => ({ value: el.index, label: el.name }))
                        return {
                            ...el,
                            sheets
                        }
                    });

                    this.setState({
                        headerin,
                        sindex,
                        sheetArray,
                        file: files
                    }, () => {
                        this.props.callback(this.props.skey, {
                            aiExtraction: this.state.aiExtraction,
                            sindex: this.state.sindex,
                            headersin: this.state.headerin,
                            headers: this.state.headers,
                            format: this.state.format,
                            sheetArray: this.state.sheetArray,
                            file: this.state.file,
                            filterName: this.state.filterName,
                            filterValue: this.state.filterValue
                        });
                    })
                }
            }
            else {
                this.setState({
                    file: files
                }, () => {
                    this.getHeader(() => {
                        if (this.state.headers.length > 0) this.setState({
                            disabledNextStep: false
                        });
                        this.setFilterSelect(this.state.headers);

                        this.props.callback(this.props.skey, {
                            aiExtraction: this.state.aiExtraction,
                            sindex: this.state.sindex,
                            headersin: this.state.headerin,
                            headers: this.state.headers,
                            format: this.state.format,
                            sheetArray: this.state.sheetArray,
                            file: this.state.file,
                            filterName: this.state.filterName,
                            filterValue: this.state.filterValue
                        });
                    });
                })
            }
        });
    }

    componentDidMount() {
        const { data } = this.props;
        if (data) {
            const {
                sindex, headersin: headerin = this.state.headerin, format,
                headers = [], sheetArray = [], file, filterName, filterValue, 
                aiExtraction = false, aiExtractionInstruction = "", aiStatus = null, aiExtractedData = null
            } = data;

            if (headers) {
                this.setFilterSelect(headers);
            }
            this.setState({
                sindex: sindex !== undefined ? sindex : this.state.sindex,
                headerin,
                headers,
                format,
                sheetArray,
                file: file || this.state.file,
                filterName: filterName ? filterName : this.state.filterName,
                filterValue: filterValue ? filterValue : this.state.filterValue,
                aiExtraction: aiExtraction ? aiExtraction : this.state.aiExtraction,
                aiExtractionInstruction: aiExtractionInstruction ? aiExtractionInstruction : this.state.aiExtractionInstruction,
                aiStatus: aiStatus ? aiStatus : this.state.aiStatus,
                aiExtractedData: aiExtractedData ? aiExtractedData : this.state.aiExtractedData
            }, () => {
                if (this.state.headers.length > 0) this.setState({
                    disabledNextStep: false
                });
            })
        }
    }

    cloudStorageDataCallback(platform, data, otherData) {
        this.setState({
            showLoading: true
        }, () => {
            const { name, file } = otherData;
            fetch(data)
                .then((resp) => resp.arrayBuffer())
                .then((blob) => {
                    const { mimeType: type } = file;
                    const createdFile = new File([blob], name, { type });
                    this.setState({
                        fileInput: createdFile,
                        showLoading: false
                    });
                })
                .catch(() => {
                    commonFunction.showAlert("Unable to download the file!", 'error');
                });
        });
    }

    render() {
        const supportedMimeTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel"
        ];

        if (!this.state.aiExtraction) {
            supportedMimeTypes.push("text/xml", "application/json");
        }

        return (
            <Fragment>
                <div className="form-container">
                    <div className="form-group">
                        <div className="required">
                            <label className="custom-input normal-text" data-type="checkbox">
                                Is AI Extraction required?
                                <input type="checkbox"
                                    name="ai-extraction"
                                    value={true}
                                    checked={this.state.aiExtraction}
                                    onChange={(e) => this.setState({ aiExtraction: e.target.checked })}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    {this.state.aiExtraction && (
                        <>
                            <div className="form-group has-field">
                                <label htmlFor="input-data">Instruction for AI Extraction (Optional)</label>
                                <textarea
                                    type="text"
                                    id="input-data"
                                    className="input-field"
                                    placeholder="Enter instruction for AI Extraction (Optional)"
                                    autoComplete="off"
                                    onChange={(e) => this.setState({ aiExtractionInstruction: e.target.value })}
                                    value={this.state.aiExtractionInstruction}
                                />
                            </div>
                            {this.state.aiStatus && (
                                <AIStatus aiStatus={this.state.aiStatus} />
                            )}
                        </>
                    )}

                    <FileUpload
                        file={this.state.fileInput}
                        link={this.state.aiExtraction ? {} : {
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": `${config.API_URL}api/v1/document/getxlsxsheets`,
                            "application/vnd.ms-excel": `${config.API_URL}api/v1/document/getxlsxsheets`,
                            "text/xml": undefined,
                            "application/json": undefined
                        }}
                        skey="inputFile"
                        callback={this.fileUploadCallback}
                        acf={supportedMimeTypes.join(",")}
                        isMultiple={true}
                    />

                    <div className="or-separator" />

                    <CloudStorage
                        callback={this.cloudStorageDataCallback}
                        data={{
                            platform: "",
                            data: ""
                        }}
                        fileSelect={true}
                        acceptedMime={[
                            "text/xml", "application/json",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            "application/vnd.ms-excel"
                        ]}
                    />

                    {this.state.showLoading &&
                        <div className="loading-screen">
                            Downloading file from cloud...
                        </div>
                    }

                    {
                        (this.state.format === "xlsx" || this.state.headers.length > 0) && <div className="line-separator" />
                    }

                    {
                        !this.state.aiExtraction &&
                        this.state.format === 'xlsx' &&
                        this.state.sheetArray.length > 0 && (
                            <SelectExcelSheet
                                sheetArray={this.state.sheetArray}
                                headerin={this.state.headerin}
                                sindex={this.state.sindex}
                                setformInput={this.setformInput}
                            />
                        )
                    }

                    {
                        this.state.aiExtraction &&
                        this.state.aiExtractedData &&
                        this.state.aiStatus &&
                        this.state.aiStatus.status === 'completed' && (
                            <AIExtractedDataReview
                                data={this.state.aiExtractedData}
                                onDataChange={this.handleAIExtractedDataChange}
                            />
                        )
                    }

                    {this.state.headers.length > 0 && !this.state.aiExtraction &&
                        <div className="form-group has-field">
                            <label htmlFor="filter">Filter</label>
                            <div className="flex-container vertical-middle" >
                                <div className="flexbox" style={{ 'width': '48%', 'margin': '0px' }} >
                                    <Select
                                        id="filter"
                                        className="input-select"
                                        isSearchable={true}
                                        placeholder="Select the header"
                                        name="filterName"
                                        options={this.state.filterSelect}
                                        onChange={(e) => this.setformInputNoTarget(e, 'filterName')}
                                    />
                                </div>
                                <div className="flexbox" style={{ 'width': '4%', 'textAlign': 'center' }}>~=</div>
                                <div className="flexbox" style={{ 'width': '48%', 'margin': '0px' }} >
                                    <input
                                        style={{ 'borderTop': 0, 'borderLeft': 0, 'borderRight': 0 }}
                                        type="text"
                                        className="input-field"
                                        placeholder="Matching value expression"
                                        autoComplete="off"
                                        value={this.state.filterValue}
                                        onChange={(e) => this.setformInput(e, 'filterValue')}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="footer text-right">
                    <button
                        className="btn moral"
                        disabled={this.state.disabledNextStep}
                        onClick={() => this.props.callback('stepNumber', 1)}
                    >Next Step</button>
                </div>
            </Fragment>
        );
    }
}

export default UploadDataFile;
